export const primaryColor = '#d50237';
export const secondaryColor = '#FFFFFD';
export const tertiaryColor = '#030200';
export const lightBackground = '#f5f5f5';
